<template>
  <b-overlay :show="load" rounded="sm">
    <b-card header-bg-variant="#0a2c80">
      <b-tabs content-class="mt-3">
        <b-tab :title="time.title" v-for="time in timeLine" :key="time.id" lazy>
          <div class="media-list media-bordered">
            <b-media v-for="(phas, indexPhas) in time.phases" :key="phas.code">
              <h4 class="media-heading">
                {{ indexPhas + 1 + " - " + phas.title }}
              </h4>
              <b-card-text>
                <div class="row">
                  <div class="col-md-12">
                    <table
                      class="table table-striped"
                      v-if="phas.type == 'data'"
                    >
                      <thead>
                        <tr>
                          <th scope="col">عنوان</th>
                          <th scope="col">{{ $t("activities.submitDate") }}</th>
                          <th scope="col">الحاله</th>
                          <th scope="col">التعلقات</th>
                          <th scope="col"></th>
                          <th scope="col">القرار</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(phase, index) in phaseData(phas)"
                          :key="index"
                        >
                          <th scope="row">
                            {{ $t(`master.` + phase.key) }}
                          </th>
                          <td class="text-success">
                            {{ moment(phase.updated_at).fromNow() }}
                          </td>
                          <td>
                            <b-badge
                              variant="light-danger"
                              v-if="variant(phase)"
                            >
                              في انتظار الموافقة
                            </b-badge>
                            <b-badge
                              variant="light-danger"
                              v-else-if="phase.master_key_status.value === 0"
                            >
                              تم الرفض
                            </b-badge>
                            <b-badge
                              variant="light-success"
                              v-else-if="phase.master_key_status.value === 1"
                            >
                              تم الموافقة
                            </b-badge>
                          </td>
                          <td>
                            <b-button
                              v-b-modal.modal-xl
                              @click="commentableid = phase.id"
                              variant="outline-info"
                              block
                            >
                              عرض التعلقات
                            </b-button>
                          </td>
                          <td>
                            <a
                              class="btn btn-outline-primary"
                              :href="phase.data_path"
                            >
                              {{ $t("activities.press_to_download") }}
                            </a>
                          </td>
                          <td>
                            <input
                              v-if="
                                phas.accreditation &&
                                  currentTeacherType &&
                                  phas.accreditation == currentTeacherType &&
                                  checkPreviousStep(phas.code) &&
                                  variant(phase) &&
                                  (phas.code == 'deliverables_1' ||
                                    phas.code == 'deliverables_2' ||
                                    phas.code == 'deliverables_3' ||
                                    phas.code == 'deliverables_4')
                              "
                              type="number"
                              min="1"
                              class="form-control mb-1"
                              placeholder="الدرجة"
                              v-model="phase.mark"
                            />
                            <b-dropdown
                              v-if="
                                phas.accreditation &&
                                  currentTeacherType &&
                                  phas.accreditation == currentTeacherType &&
                                  checkPreviousStep(phas.code) &&
                                  variant(phase)
                              "
                              text="القرار"
                              variant="outline-info"
                              block
                              right
                            >
                              <b-dropdown-item
                                v-for="dec in decision.filter((a) => a.id < 2)"
                                :key="dec.id"
                                @click="approve(phase, dec.id)"
                              >
                                {{ dec.title }}
                              </b-dropdown-item>
                            </b-dropdown>
                            <div v-if="!variant(phase)">
                              <h5>اعتمد بواسطه</h5>

                              <b-badge variant="light-info">
                                {{
                                  phase.master_key_status.user.full_name
                                }}</b-badge
                              >
                              <h4
                                class="mt-1"
                                v-if="
                                  !variant(phase) &&
                                    phase.master_key_status.mark != null &&
                                    phase.master_key_status.mark != 0
                                "
                              >
                                <b-badge variant="success">
                                  {{ phase.master_key_status.mark }}</b-badge
                                >
                              </h4>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table table-striped"
                      v-else-if="
                        phas.type == 'status' || phas.type == 'decision'
                      "
                    >
                      <thead>
                        <tr>
                          <th scope="col">عنوان</th>

                          <th scope="col">الحاله</th>
                          <th scope="col">القرار</th>
                          <th scope="col">{{ $t("activities.submitDate") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(phase, index) in phaseStatus(phas)"
                          :key="index"
                        >
                          <td scope="row">{{ phas.title }}</td>
                          <td>
                            <b-badge v-if="phase.value === -1">
                              في انتظار الموافقة
                            </b-badge>
                            <b-badge
                              :variant="decisionSelect(phase.value).variant"
                              v-else
                            >
                              {{ decisionSelect(phase.value).title }}
                            </b-badge>
                          </td>

                          <td>
                            <b-dropdown
                              v-if="
                                phase.value == -1 &&
                                  phas.accreditation &&
                                  currentTeacherType &&
                                  phas.accreditation == currentTeacherType &&
                                  checkPreviousStep(phas.code)
                              "
                              text="القرار"
                              variant="outline-info"
                              block
                              right
                            >
                              <b-dropdown-item
                                v-for="dec in decisionData()"
                                :key="dec.id"
                                @click="
                                  approve({ id: 0, key: phas.code }, dec.id)
                                "
                              >
                                {{ dec.title }}
                              </b-dropdown-item>
                            </b-dropdown>
                            <div v-if="phase.value != -1">
                              <h5>اعتمد بواسطه</h5>
                              <b-badge variant="light-info">
                                {{ phase.user.full_name }}</b-badge
                              >
                            </div>
                          </td>
                          <td>
                            <span
                              class="text-success"
                              v-if="phase.value !== -1"
                            >
                              {{ moment(phase.updated_at).fromNow() }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table table-striped"
                      v-else-if="phas.type == 'online'"
                    >
                      <thead>
                        <tr>
                          <th scope="col">عنوان</th>

                          <th scope="col">الحاله</th>
                          <th scope="col">القرار</th>
                          <th scope="col">{{ $t("activities.submitDate") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(phase, index) in phaseStatus(phas)"
                          :key="index"
                        >
                          <td scope="row">{{ phas.title }}</td>
                          <th scope="row">
                            {{ setDate(phase, phas.code) }}
                            <b-form-group
                              v-if="
                                phase.value == -1 &&
                                  phas.accreditation &&
                                  currentTeacherType &&
                                  phas.accreditation == currentTeacherType &&
                                  checkPreviousStep(phas.code)
                              "
                            >
                              <h5>موعد هيكلة الخطة</h5>
                              <flat-pickr
                                v-model="defenseDate[phas.code]"
                                class="form-control"
                                :config="{
                                  enableTime: true,
                                  dateFormat: 'Y-m-d H:i',
                                }"
                              />
                            </b-form-group>
                         
                          </th>
                          <td>
                             <b-button
                              v-if="
                                phase.value == -1 &&
                                  phas.accreditation &&
                                  currentTeacherType &&
                                  phas.accreditation == currentTeacherType &&
                                  checkPreviousStep(phas.code)
                              "
                              @click="saveDefense(phase, phas.code)"
                              variant="outline-primary"
                              block
                            >
                              حفظ
                            </b-button>
                            <!-- <b-dropdown
                              v-if="
                                phase.online_session != null &&
                                  phase.online_value == null &&
                                  phas.accreditation &&
                                  currentTeacherType && phas.accreditation ==
                                    currentTeacherType
                              "
                              text="القرار"
                              variant="outline-info"
                              block
                              right
                            >
                              <b-dropdown-item
                                @click="updateOnlineValue(phase, 1)"
                                >قبول</b-dropdown-item
                              >

                              <b-dropdown-item
                                @click="updateOnlineValue(phase, 0)"
                                >رفض</b-dropdown-item
                              >
                            </b-dropdown> -->
                          </td>
                          <td>
                            <template v-if="phase.online_session">
                              <template v-if="checkTime(phase.online_session)">
                                <b-badge class="badge-glow">
                                  لم تبدأ بعد
                                </b-badge>
                              </template>

                              <b-dropdown
                                v-else
                                block
                                :text="$t('site.action')"
                                variant="outline-primary"
                              >
                                <b-dropdown-item
                                  @click="openLive(phase.online_session)"
                                  v-if="phase.online_session.is_end == 0"
                                >
                                  <i
                                    class="fas fa-door-open"
                                    style="
                                      display: inline-block;
                                      margin: ;
                                      padding: 1px 5px;
                                    "
                                  ></i>
                                  <span class="text-warning"
                                    >دخول المحاضرة
                                  </span>
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="phase.online_session.is_end == 0"
                                >
                                  <a
                                    style="padding: 5px; cursor: pointer"
                                    class="
                                      dropdown-item
                                      get-online-session-links
                                    "
                                    @click="end(phase.online_session)"
                                  >
                                    <i
                                      class="fas fa-stop-circle"
                                      style="
                                        display: inline-block;
                                        margin: 0;
                                        padding: 1px 5px;
                                      "
                                    ></i>
                                    <span
                                      class="text-danger"
                                      style="
                                        display: inline-block;
                                        margin: 0;
                                        padding: 1px 5px;
                                      "
                                    >
                                      إنهاء الاجتماع</span
                                    >
                                  </a>
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="phase.online_session.is_end == 1"
                                  :to="{
                                    name: 'OnlineDetails',
                                    params: {
                                      id: phase.online_session.id,
                                    },
                                  }"
                                >
                                  <a
                                    style="padding: 5px; cursor: pointer"
                                    class="
                                      dropdown-item
                                      get-online-session-links
                                    "
                                  >
                                    <i
                                      class="fas fa-photo-video"
                                      style="
                                        display: inline-block;
                                        margin: 0;
                                        padding: 1px 5px;
                                      "
                                    ></i>
                                    <span
                                      class="text-info"
                                      style="
                                        display: inline-block;
                                        margin: 0;
                                        padding: 1px 5px;
                                      "
                                    >
                                      تحميل ملف الفيديو</span
                                    >
                                  </a>
                                </b-dropdown-item>

                                <b-dropdown-item
                                  v-if="phase.online_session.is_end == 1"
                                  @click="setData(phase.online_session)"
                                  :to="{
                                    name: 'SessionAttendance',
                                    params: {
                                      session_room_id:
                                        phase.online_session.room_id,
                                      session_id: phase.online_session.id,
                                    },
                                  }"
                                >
                                  <a
                                    style="padding: 5px; cursor: pointer"
                                    class="
                                      dropdown-item
                                      get-online-session-links
                                    "
                                  >
                                    <i
                                      class="fas fa-clipboard-check"
                                      style="
                                        display: inline-block;
                                        margin: 0;
                                        padding: 1px 5px;
                                      "
                                    ></i>
                                    <span
                                      class="text-info"
                                      style="
                                        display: inline-block;
                                        margin: 0;
                                        padding: 1px 5px;
                                      "
                                    >
                                      {{
                                        $t("attendance.attendance_record")
                                      }}</span
                                    >
                                  </a>
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-card-text>
            </b-media>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal id="modal-xl" size="lg" title="  عرض التعلقات">
      <b-row v-for="file in userData" :key="file.id">
        <b-col lg="12" v-if="commentableid != 0 && commentableid == file.id">
          <comment-vue
            :commentableid="commentableid"
            :commentabletype="'App\MastersData'"
            ref="comment"
          ></comment-vue>
        </b-col> </b-row
    ></b-modal>
  </b-overlay>
</template>

<script>
import MastersController from "@/Controllers/MastersController";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import Auth from "@/Apis/Auth";
import MastersDataController from "@/Controllers/MastersDataController";
import CommentVue from "@/views/Page/Activities/components/Comment.vue";
import flatPickr from "vue-flatpickr-component";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import SettingController from "@/Controllers/SettingController";
import MasterTeachersController from "@/Controllers/MasterTeachersController";

export default {
  components: { CommentVue, flatPickr },
  data() {
    return {
      timeLine: [],
      status: [],
      status: [],
      decision: [],
      commentableid: 0,
      masterId: this.$route.params.masterId,

      userId: this.$route.params.userId,
      load: false,
      department_approval: null,
      college_approval: null,
      phase: null,
      userData: [],
      defenseDate: [],
      time: "",

      currentTeacherType: "",
      currentOrderApprove: null,
    };
  },
  async created() {
    this.getData();
    this.getCurrentTeacherData();
    //log user_type
  },
  methods: {
    async getData() {
      this.load = true;
      this.time = await new SettingController().time();

      const res = await new MastersDataController().GetAll({
        filter: "user_id|" + this.userId + "&&master_id|" + this.masterId,
        with: ["masterKeyStatus", "masterKeyStatus.user"],
      });
      this.userData = res;
      console.log(res);
      const _mxc = new MastersController();
      this.timeLine = _mxc.timeLine();
      console.log(this.timeLine);
      this.decision = _mxc.decision();
      this.status = await new MasterKeyStatusController().GetAll({
        filter: "master_id|" + this.masterId,
        with: ["user", "onlineSession"],
      });

      // const department_approval = this.proposalApproval.find(
      //   (a) => a.key == "department_approval"
      // );

      // if (department_approval) this.department_approval = department_approval;
      // const college_approval = this.proposalApproval.find(
      //   (a) => a.key == "college_approval"
      // );

      // if (college_approval) this.college_approval = college_approval;

      // const phase = this.proposalApproval.find(
      //   (a) => a.key == "phase"
      // );

      // if (phase) {
      //   this.phase = phase;
      //   if (phase.value > 1) {
      //     this.defenseDate =
      //       phase.online_session.start_in;
      //   }
      // }

      this.load = false;
    },
    async getCurrentTeacherData() {
      //
      let current_user_id = Auth.USER.id;
      let res = await new MasterTeachersController().getRole(
        current_user_id,
        this.masterId
      );
      if (res) {
        this.currentTeacherType = res.type;
      } else {
        let res_2 = await new MasterTeachersController().getGeneralRole(
          current_user_id
        );
        if (res_2 && res_2.length > 0) {
          this.currentTeacherType = res_2[0].name;
        }
      }
    },
    checkTime(item) {
      const check = new Date(this.time.SERVERTIME);
      const stDate = Auth.GetDateTimeZone(item.start_in, true);
      if (check.getTime() >= stDate.getTime()) return false;
      return true;
    },
    async saveDefense(phase, index) {
      let data = {
        title: this.$i18n.t("master." + index),
        description: this.$i18n.t("master." + index),
        start_in: this.defenseDate[index],
        end_in: "",
        room_id: 0,
        user_id : this.$route.params.userId,
        master_id : this.$route.params.masterId
      };
      console.log(phase);
      if (phase.value > 1) data.id = phase.value;
      let ret = await new OnlineSessionController().From(
        data,
        "FormData",
        true
      );
      if (phase.value == -1) {
        phase.value = ret.data.id;
        phase.key = index;
        phase.closed = 1;
        phase.user_id = Auth.USER.id;
        phase.master_id = this.masterId;
        phase.masters_data_id = 0;
        await new MasterKeyStatusController().From(phase, "FormData");
      }
    },
    phaseData(phases) {
      return this.userData.filter((a) => a.key == phases.code);
    },
    phaseStatus(phases) {
      let status = this.status.filter((a) => a.key == phases.code);
      if (status.length == 0) status = [{ value: -1 }];
      return status;
    },
    decisionData(type) {
      if (type == "status") return this.decision.filter((a) => a.id < 2);
      return this.decision;
    },
    decisionSelect(value) {
      console.log(this.decision);
      console.log(value);
      return this.decision.find((a) => a.id == value);
    },
    setDate(phase, index) {
      if (!phase.online_session) return;
      this.defenseDate[index] = phase.online_session.start_in;
      console.log(this.defenseDate, index);
    },
    variant(item) {
      if (
        item.master_key_status === null ||
        item.master_key_status.value === null ||
        item.master_key_status.value === ""
      ) {
        return true;
      }
    },

    checkStatus(key) {
      if (this.status.length == 0) return true;
      const find = this.status.find((a) => a.key == key);
      if (find) return false;

      return true;
    },
    checkPreviousStep(key) {
      //first step
      if (key == "suggested_title") return true;
      // if delirabilites
      if (
        key == "deliverables_2" ||
        key == "deliverables_3" ||
        key == "deliverables_4"
      ) {
        //check if defend_the_plan is approved [value > 1]
        let defend_the_plan = this.status.find(
          (a) => a.key == "defend_the_plan"
        );
        if (defend_the_plan) {
          if (defend_the_plan.value > 1) return true;
        }
      }
      // defend the plan
      if(key == "defend_the_plan"){
        let upload_the_three_seasons_1 = this.status.find(
          (a) => a.key == "upload_the_three_seasons_1"
        );
        if (upload_the_three_seasons_1) {
          if (upload_the_three_seasons_1.value == 1) return true;
        }
      }
      //get keys of all phases in order
      let phases_keys = this.timeLine.map((a) => a.phases.map((b) => b.code));
      let keys = [];
      phases_keys.forEach((element) => {
        element.forEach((element2) => {
          keys.push(element2);
        });
      });
      // get current key index
      let index = keys.indexOf(key);
      // get previous key
      let previous_key = keys[index - 1];
      // check if previous key is approved
      let previous_key_status = this.status.find((a) => a.key == previous_key);
      if (previous_key_status) {
        if (previous_key_status.value == 1) return true;
      }
      // before the online steps as value is > 1 ; room_id
      if (
        key == "supervisors_decision" ||
        key == "research_readiness_defense_evaluation_committee" ||
        key == "deliverables_1" ||
        key == "upload_the_three_seasons_1"
      ) {
        if (previous_key_status) {
          if (previous_key_status.value > 1 || previous_key_status.value == "")
            return true;
        }
      }

      return false;
    },

    async openLive(data) {
      await new OnlineSessionController().joinLecture(data.id);
    },
    async end(item) {
      await new OnlineSessionController().end({
        id: item.id,
        meetingID: item.id,
      });
      // this.$refs.table.refresh();
    },
    async approve(item, value) {
      let master_key_status = item.master_key_status;
      if (!item.master_key_status)
        master_key_status = { masters_data_id: item.id };
      master_key_status.key = item.key;
      master_key_status.value = value;
      master_key_status.closed = 1;
      master_key_status.user_id = Auth.USER.id;
      master_key_status.master_id = this.masterId;
      if (item.mark != null && item.mark != 0) {
        master_key_status.mark = item.mark;
      }
      await new MasterKeyStatusController().From(master_key_status, "FormData");
      this.getData();
    },
    async updateOnlineValue(item, value) {
      await new MasterKeyStatusController().Updata({
        id: item.id,
        online_value: value,
      });
      this.getData();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.main-timeline {
  font-family: "Poppins", sans-serif;
  padding: 25px 10px;
}

.main-timeline:after {
  content: "";
  display: block;
  clear: both;
}

.main-timeline .timeline {
  width: calc(50% + 9px);
  padding: 20px 30px 20px 0;
  margin: -20px 0 0 0;
  border-radius: 20px;
  border: 10px solid transparent;
  border-right: 10px solid #fff;
  float: left;
  position: relative;
}

.main-timeline .timeline:before,
.main-timeline .timeline:after {
  content: "";
  background-color: #da2677;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  position: absolute;
  right: -18px;
  bottom: 40px;
}

.main-timeline .timeline:after {
  border-radius: 3px;
  transform: rotate(45deg);
  right: 20px;
}

.main-timeline .timeline-content {
  color: #fff;
  background: linear-gradient(#d02578, #da2677);
  min-height: 130px;
  padding: 0 0 20px;

  border-radius: 5px;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.avtive {
  box-shadow: 0 0 20px rgba(0, 0, 0, 1);
}

.main-timeline .timeline-content:hover {
  text-decoration: none;
}

.main-timeline .timeline-icon {
  font-size: 40px;
  line-height: 40px;
  position: absolute;
  bottom: 15px;
  right: 16px;
}

.main-timeline .title {
  color: #da2677;
  background-color: #fff;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: center;
  text-transform: uppercase;
  padding: 12px;
  margin: 0 0 5px;
}

.main-timeline .description {
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 20px;
  margin: 20px 80px 0 20px;
}

.main-timeline .timeline:nth-child(even) {
  float: right;
  padding: 20px 0 20px 30px;
  margin: -20px 0 0 0;
  border-right: none;
  border-left: 10px solid #fff;
}

.main-timeline .timeline:nth-child(even):before {
  right: auto;
  left: -18px;
}

.main-timeline .timeline:nth-child(even):after {
  right: auto;
  left: 20px;
}

.main-timeline .timeline:nth-child(even) .timeline-icon {
  left: auto;
  right: 16px;
}

.main-timeline .timeline:nth-child(even) .description {
  margin: 20px 20px 0 80px;
}

.main-timeline .timeline:nth-child(4n + 2):before,
.main-timeline .timeline:nth-child(4n + 2):after {
  background-color: #4eb543;
}

.main-timeline .timeline:nth-child(4n + 2) .timeline-content {
  background: linear-gradient(#80b02c, #4eb543);
}

.main-timeline .timeline:nth-child(4n + 2) .title {
  color: #4eb543;
}

.main-timeline .timeline:nth-child(4n + 3):before,
.main-timeline .timeline:nth-child(4n + 3):after {
  background-color: #3a3270;
}

.main-timeline .timeline:nth-child(4n + 3) .timeline-content {
  background: linear-gradient(#65286d, #3a3270);
}

.main-timeline .timeline:nth-child(4n + 3) .title {
  color: #3a3270;
}

.main-timeline .timeline:nth-child(4n + 4):before,
.main-timeline .timeline:nth-child(4n + 4):after {
  background-color: #0a2c80;
}

.main-timeline .timeline:nth-child(4n + 4) .timeline-content {
  background: linear-gradient(#2fd8d8, #0a2c80);
}

.main-timeline .timeline:nth-child(4n + 4) .title {
  color: #0a2c80;
}

@media screen and (max-width: 767px) {
  .main-timeline .timeline,
  .main-timeline .timeline:nth-child(even) {
    width: 100%;
    padding: 20px 0 20px 30px;
    margin: -25px 0 0;
    border-left: 10px solid #fff;
    border-right: none;
  }

  .main-timeline .timeline:before,
  .main-timeline .timeline:nth-child(even):before {
    right: auto;
    left: -17px;
  }

  .main-timeline .timeline:after,
  .main-timeline .timeline:nth-child(even):after {
    right: auto;
    left: 20px;
  }

  .main-timeline .description,
  .main-timeline .timeline:nth-child(even) .description {
    margin: 20px 20px 0 80px;
  }

  .main-timeline .timeline-icon,
  .main-timeline .timeline:nth-child(even) .timeline-icon {
    right: 16px;
    left: auto;
  }
}

@media screen and (max-width: 576px) {
  .main-timeline .timeline-content {
    padding-bottom: 70px;
  }

  .main-timeline .description,
  .main-timeline .timeline:nth-child(even) .description {
    margin: 20px 20px 0 20px;
  }
}
</style>
